export default "__VITE_ASSET__CZCTojSR__"